// extracted by css-extract-rspack-plugin
var _1 = "icon__joUJv";
export { _1 as "icon" }
export default { "icon": _1 }
